import { render, staticRenderFns } from "./ClinicNurseDashboardTop.vue?vue&type=template&id=3fc8add1&"
import script from "./ClinicNurseDashboardTop.vue?vue&type=script&lang=js&"
export * from "./ClinicNurseDashboardTop.vue?vue&type=script&lang=js&"
import style0 from "./ClinicNurseDashboardTop.vue?vue&type=style&index=0&id=3fc8add1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports